
{
  "familyId": "TOPO-NL-BUURLANDEN",
  "questions": [
    {
      "id": "TOPO-NL-BUURLANDEN-001",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Welke landen grenzen aan Nederland?",
      "context": null,
      "options": [
        "België en Duitsland",
        "België en Frankrijk",
        "Duitsland en Denemarken",
        "België, Duitsland en Luxemburg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "nl_buurlanden_basis",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Nederland heeft twee buurlanden op het land: België in het zuiden en Duitsland in het oosten. In het noorden en westen grenst Nederland aan de Noordzee.",
        "distractorExplanations": {
          "0": "Correct! Nederland grenst aan België (zuiden) en Duitsland (oosten).",
          "1": "Fout: Nederland grenst niet aan Frankrijk. Wel aan België en Duitsland.",
          "2": "Fout: Nederland grenst niet aan Denemarken. Wel aan België en Duitsland.",
          "3": "Fout: Luxemburg grenst niet aan Nederland. Nederland heeft twee buurlanden: België en Duitsland."
        }
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-002",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "In welke richting ligt België ten opzichte van Nederland?",
      "context": null,
      "options": ["In het zuiden", "In het oosten", "In het noorden", "In het westen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "nl_belgie_richting",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "België ligt in het zuiden van Nederland. Duitsland ligt in het oosten. In het noorden en westen is de Noordzee.",
        "distractorExplanations": {
          "0": "Correct! België ligt in het zuiden van Nederland.",
          "1": "Fout: in het oosten ligt Duitsland, niet België.",
          "2": "Fout: in het noorden is de Noordzee. België ligt in het zuiden.",
          "3": "Fout: in het westen is de Noordzee. België ligt in het zuiden."
        }
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-003",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Wat is de hoofdstad van Duitsland, het buurland van Nederland?",
      "context": null,
      "options": ["Berlijn", "München", "Hamburg", "Frankfurt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "nl_buurland_duitsland_hoofdstad",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "De hoofdstad van Duitsland is Berlijn. Duitsland is het buurland van Nederland in het oosten. München, Hamburg en Frankfurt zijn grote steden in Duitsland, maar niet de hoofdstad.",
        "distractorExplanations": {
          "0": "Correct! Berlijn is de hoofdstad van Duitsland.",
          "1": "Fout: München is een grote stad in het zuiden van Duitsland, maar niet de hoofdstad. De hoofdstad is Berlijn.",
          "2": "Fout: Hamburg is een grote havenstad in het noorden van Duitsland, maar niet de hoofdstad. De hoofdstad is Berlijn.",
          "3": "Fout: Frankfurt is een grote financiële stad in Duitsland, maar niet de hoofdstad. De hoofdstad is Berlijn."
        }
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-004",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Wat is de hoofdstad van België, het buurland van Nederland?",
      "context": null,
      "options": ["Brussel", "Antwerpen", "Gent", "Luik"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "nl_buurland_belgie_hoofdstad",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "De hoofdstad van België is Brussel. België is het buurland van Nederland in het zuiden. Antwerpen, Gent en Luik zijn grote steden in België, maar niet de hoofdstad.",
        "distractorExplanations": {
          "0": "Correct! Brussel is de hoofdstad van België.",
          "1": "Fout: Antwerpen is de grootste stad van België, maar niet de hoofdstad. De hoofdstad is Brussel.",
          "2": "Fout: Gent is een grote stad in België, maar niet de hoofdstad. De hoofdstad is Brussel.",
          "3": "Fout: Luik (Liège) is een stad in het oosten van België, maar niet de hoofdstad. De hoofdstad is Brussel."
        }
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-005",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Welke stelling over de buurlanden van Nederland is JUIST?",
      "context": null,
      "options": [
        "Nederland heeft twee buurlanden: België en Duitsland.",
        "Nederland heeft drie buurlanden: België, Duitsland en Luxemburg.",
        "Nederland heeft één buurland: Duitsland.",
        "Nederland heeft geen buurlanden, alleen de Noordzee."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "nl_buurlanden_overzicht",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Nederland heeft precies twee buurlanden op het land: België (zuiden) en Duitsland (oosten). In het noorden en westen grenst Nederland aan de Noordzee. Luxemburg grenst niet aan Nederland.",
        "distractorExplanations": {
          "0": "Correct! Nederland heeft twee buurlanden: België en Duitsland.",
          "1": "Fout: Luxemburg grenst niet aan Nederland. Nederland heeft twee buurlanden: België en Duitsland.",
          "2": "Fout: Nederland heeft ook België als buurland (in het zuiden). Duitsland ligt in het oosten.",
          "3": "Fout: Nederland grenst wel aan andere landen. België (zuiden) en Duitsland (oosten) zijn de buurlanden."
        }
      }
    }
  ]
}
